module.exports = __webpack_public_path__ + "static/media/look_2.e3bed243.png";